/**
 * AroonOsc — Oscilador Aroon.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLOscilators.cs, classe
 * FML.AroonOsc, que consome o FML.Aroon de FMLVolatilidade.cs). Painel
 * próprio, 1 linha + linha de referência zero:
 *
 *   UP   = (N − HHVBARS(C,N)) / N * 100
 *   DOWN = (N − LLVBARS(C,N)) / N * 100
 *   Osc  = UP − DOWN
 *
 * ⚠️ O Aroon do legado usa HHVBARS/LLVBARS do **FECHAMENTO**; o `aroon` do
 * odin usa máxima/mínima — são fórmulas diferentes, por isso chave própria.
 * Portado na ORDEM do engine (UP e DOWN separados, depois a subtração) para
 * manter o bit-exact. Paridade provada em
 * __tests__/aroonOsc.silverlight.test.js.
 */
import { hhvBars, llvBars, sub, div, mul } from "./silverlightDsl";
import { AroonOsc as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period } = options;
    const close = data.map((d) =>
      Number.isFinite(d.close) ? d.close : Number.NaN,
    );

    const up = mul(div(sub(period, hhvBars(close, period)), period), 100);
    const down = mul(div(sub(period, llvBars(close, period)), period), 100);
    const osc = sub(up, down);

    return osc.map((v) => (Number.isFinite(v) ? v : undefined));
  }

  calculator.undefinedLength = function () {
    // HHVBARS/LLVBARS emitem desde a barra 0 (sem warm-up NaN).
    return 0;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
